import { render, staticRenderFns } from "./ListaUsuarios.vue?vue&type=template&id=65d864b2"
import script from "./ListaUsuarios.vue?vue&type=script&lang=js"
export * from "./ListaUsuarios.vue?vue&type=script&lang=js"
import style0 from "./ListaUsuarios.vue?vue&type=style&index=0&id=65d864b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports